module.exports = __webpack_public_path__ + "images/stickers/check@2x.5168d92437a5fc166632.png";